module.exports = __webpack_public_path__ + "img/cases02-bg.2fb0da46.jpg";